import { showNotification } from '@ospace/shared'
import { IconCopy, IconCopyCheck } from '@tabler/icons-react'
import { toBlob } from 'html-to-image'
import { useCallback, useEffect, useRef, useState } from 'react'

export const useCopyWidget = (title: string) => {
  const ref = useRef<HTMLDivElement>(null)
  const resetTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)
  const [copying, setCopying] = useState(false)

  const [copySuccess, setCopySuccess] = useState(false)

  const scheduleReset = useCallback(() => {
    if (resetTimeout.current) {
      clearTimeout(resetTimeout.current)
    }
    resetTimeout.current = setTimeout(() => setCopySuccess(false), 3000)
  }, [])

  const copyHandler = useCallback(() => {
    if (ref.current === null) {
      return
    }
    setCopying(true)
    toBlob(ref.current, { cacheBust: true, backgroundColor: 'white', type: 'image/png' })
      .then((blob) => {
        if (!blob) {
          showNotification({
            type: 'error',
            message: 'Copy failed',
          })
          setCopying(false)
          return
        }
        navigator.clipboard.write([
          new ClipboardItem({
            'image/png': blob,
          }),
        ])
        showNotification({
          type: 'success',
          message: `Copied ${title.toUpperCase()} to clipboard`,
        })
        setCopySuccess(true)
        scheduleReset()
        setCopying(false)
      })
      .catch((err) => {
        console.error(err)
        setCopying(false)
        showNotification({
          type: 'error',
          message: 'Copy failed',
        })
      })
  }, [scheduleReset, title])
  const CopyIcon = copySuccess ? IconCopyCheck : IconCopy

  useEffect(() => {
    return () => {
      if (resetTimeout.current) {
        clearTimeout(resetTimeout.current)
      }
    }
  }, [])

  return { targetRef: ref, copyHandler, CopyIcon, copySuccess, copying }
}
